import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AnalyticalLedgerAccount  {
    _originalTypeClassName = "zERP.BO.AnalyticalLedgerAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AnalyticalLedgerAccount.translate = translateService;
}
this.Transactions = [];
this.Id = null;
this.Code = null;
this.Description = null;
this.AnalyticalLedgerAccountKey = null;
this._key = this.AnalyticalLedgerAccountKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Code:any;
Description:any;
Transactions:any;
private _AnalyticalLedgerAccountKey:any;
get AnalyticalLedgerAccountKey(): any {
    return this._AnalyticalLedgerAccountKey;
  }
set AnalyticalLedgerAccountKey(value: any) {
    this._AnalyticalLedgerAccountKey = value;
    this._key = value;
  }
static setTransactions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transactions == null) $this.Transactions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transactions.length > 0) {
                    Domain.AnalyticalLedgerAccount.removeTransactions($this, $this.Transactions[0]);
                }

                Domain.AnalyticalLedgerAccount.addManyTransactions($this, copyItems);
            }
static addManyTransactions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AnalyticalLedgerAccount.addTransactions($this, items[i]);
                }
            }
static addTransactions = ($this, item) => {
                if ($this.Transactions == null) $this.Transactions = [];
                if (item == null || $this.Transactions.indexOf(item) > -1) return;
                $this.Transactions.push(item);
}
static addRangeTransactions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AnalyticalLedgerAccount.addTransactions($this, item));
            }
static removeTransactions = ($this, item) => {
                if ($this == null || $this.Transactions == null || $this.Transactions.indexOf(item) === -1) return;
                var _index = $this.Transactions.indexOf(item);
                $this.Transactions.splice(_index, 1);
}
static clearTransactions = ($this) => { $this.Transactions = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AnalyticalLedgerAccountKey == null || $this.AnalyticalLedgerAccountKey == 0;
            }


}